<template>
    <div class="edit-box" v-if="showModel">
        <div class="edit-title">
            <div>详情</div>
            <i class="iconfont" @click="close">&#xe641;</i>
            
        </div>
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="100">
            

            <div class="name-title" v-if="formData.member">
                <div class="item">所属会员：{{formData.member.name}}</div>
                <div class="item">试卷题目：{{formData.exam.title}}</div>
                <div class="item">试卷时长：{{formData.exam.time_range}}分钟</div>
                <!-- <div class="item">总得分：{{formData.exam.nanumme}}</div> -->
            </div>
           <table class="tables" border="1" style="border-collapse: collapse;">
               <tr>
                   <th>题目</th><th>选项</th><th class="ct-div">正确答案</th><th class="ct-div">你的答案</th><th class="ct-div">得分</th>
               </tr>
               <tr v-for="(item1,index1) in formData.exam.question" :key="index1">
                   <td>{{item1.title}}</td>
                   <td v-if="item1.optionA">
                       <p v-for="(item,index) in item1.optionA" :key="index">{{item.name}}、{{item.val}}</p>
                   </td>
                   <td class="ct-div">{{item1.true_answer}}</td>
                   <td class="ct-div" v-if="item1.id == formData.content[index1].id">{{formData.content[index1].answer}}</td>
                   <td class="ct-div">{{item1.grade}}</td>
               </tr>
           </table>
        </Form>
    </div>
</template>
<script>
    import moment from 'moment';
    import common from '@/common/common.js';
	
export default {
  props: {
    showModel: Boolean,
    fn: Function,
    type: Number,
    editFormData: Object
  },
  components:{
  },
  data() {
    return {
        searchUrl: this.config.urlArray.goodAll,
      disabled: false,
      tabIndex:'1',
      formData: {},
	  
      ruleCustom: {
        //验证
        courier_number: [
			{ required: true, message: '请填写快递单号', trigger: 'blur' }
        ],
      }
    };
  },
  watch: {
    showModel(val) {
        if(val){
            this.getData()
        }
    },
  },
  methods: {
     getData(){ //获取数据
        let getData = {
            params:{
                id: this.editFormData.id
            }
        }
        this.axios.get(this.config.urlArray.examresGetExamResDetail,getData).then((result) => {
            common.ajaxMsg(result.data);
            let resData = result.data.data
            this.formData = resData
            this.formData.exam.question = this.formData.exam.question.map((item,index)=>{
                    let options = item.options
                    let arrOp = []
                    for (const key in options) {
                        let obj = {name: key, val:options[key]}
                        arrOp.push(obj)
                    }
                    item.optionA = arrOp
                return item
            })
            
            console.log(this.formData)

    }).catch((err) => {
        common.msg('error','获取失败',()=>{})
    });
    },
    editForm() {
    //   this.formData = this.editFormData;
    },
    resetForm() { // 重置表单
		this.tabIndex='1',
        this.formData.id = ''
        this.$refs.formData.resetFields(); // 重置表单
    },
    close(){
		this.tabIndex='1',
		this.disabled=false
        this.fn();
    }
  }
};
</script>
<style lang="scss" scoped>
.edit-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding-bottom: 20px;
  div {
    font-size: 20px;
    font-weight: bold;
  }
  .iconfont {
    font-size: 20px;
    cursor: pointer;
    display: inline-block;
    background: rgba(154, 154, 154, 0.6);
    line-height: 100%;
    border-radius: 100%;
    padding: 3px;
    box-sizing: border-box;
    color: #fff;
    transition: all 0.3s;
  }
  .iconfont:hover{
      background: rgba(251, 24, 24, 0.6);
      transform: scale(1.2);
  }
}
.name-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0px;
}
.tables{
    width: 100%;
    th{
        font-size: 16px;
    }
    td,th{
        padding: 5px 5px;
        box-sizing: border-box;
        
    }
    .ct-div{
        text-align: center;
    }
}
</style>
